// extracted by mini-css-extract-plugin
export default {"iconLayoutContainer":"device_icon_iconLayoutContainer__6rgC1","deviceIconContainer":"device_icon_deviceIconContainer__+nkEo","deviceIcon":"device_icon_deviceIcon__yrshZ"};